import React, { useEffect, useState } from "react"
import { IoCloudUploadOutline } from "@react-icons/all-files/io5/IoCloudUploadOutline"
import Resizer from "react-image-file-resizer"
import { IoTrashSharp } from "@react-icons/all-files/io5/IoTrashSharp"
import Navigation from "../components/Navigation/Navigation"

export default function Image() {
  // Compression will be used in Peji

  const resizeFile = file =>
    new Promise(resolve => {
      Resizer.imageFileResizer(
        file,
        500,
        500,
        "JPEG",
        15,
        0,
        uri => {
          resolve(uri)
        },
        "base64"
      )
    })

  const onChange = async event => {
    const file = event.target.files[0]
    const image = await resizeFile(file)
    setImageSrc(image)

    let pictures = localStorage.getItem("dhaga-pictures")

    if (pictures) {
      pictures = JSON.parse(pictures)
    } else {
      pictures = []
    }
    // TODO: set a limit for the pictures
    if (pictures.length > 15) {
      alert("Ma picture ako awandisa, tanga wabvisa mamwe")
    } else {
      pictures.push(image)
      localStorage.setItem("dhaga-pictures", JSON.stringify(pictures))
    }
  }
  //---------------
  const [imageSrc, setImageSrc] = useState()
  const [compressedImage, setCompressedImage] = useState()
  const [storageImages, setStorageImages] = useState()

  useEffect(() => {
    let pictures = localStorage.getItem("dhaga-pictures")
    pictures = JSON.parse(pictures)
    setStorageImages(pictures)
  }, [imageSrc])

  const removeImage = e => {
    let newStorageImages = storageImages.filter(
      x => x !== storageImages[storageImages.length - 1 - e.target.id]
    )
    setNewStorageImages(newStorageImages)
  }

  const [newStorageImages, setNewStorageImages] = useState()
  useEffect(() => {
    if (newStorageImages) {
      setStorageImages(newStorageImages)
      localStorage.setItem("dhaga-pictures", JSON.stringify(newStorageImages))
    }
  }, [newStorageImages])

  return (
    <div className="h-screen bg-white">
      {/* {imageSrc && <img src={imageSrc} />} */}
      {/* {compressedImage && <img src={compressedImage} />} */}

      <div className="mx-auto w-1/2 text-center">
        Kana uchida kushandisa picture inobva muphone yako, baya upload picture
      </div>

      <div
        className="text-shona w-1/2 flex items-center h-12 justify-evenly rounded-xl mx-auto my-3 mt-6"
        style={{ backgroundColor: "rgba(0,128,128, 0.1)" }}
      >
        <span className="text-xl font-bold">
          <IoCloudUploadOutline />
        </span>
        <button onClick={() => document.getElementById("getFile").click()}>
          Upload Picture
        </button>
        <input
          onChange={onChange}
          type="file"
          id="getFile"
          className="bg-red-white w-full relative z-20 file:bg-shona file:text-white file:p-2 file:rounded-lg file:border-none none"
          placeholder="upload image"
          style={{ display: "none" }}
        ></input>
      </div>

      <div className="mx-auto w-1/2 text-center">
        kana kuti sarudza kubva pane aripo
      </div>

      <div className="flex flex-col items-center">
        {storageImages &&
          storageImages.map(x => (
            <div
              className="w-11/12 h-96 rounded-lg shadow-md mb-3"
              style={{ display: "grid", gridTemplateRows: "85% 15%" }}
            >
              <div
                className="bg-red-600"
                style={{
                  backgroundImage: `url('${
                    storageImages[
                      storageImages.length - 1 - storageImages.indexOf(x)
                    ]
                  }')`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              ></div>
              <div
                className="flex justify-center items-center"
                style={{ backgroundColor: "#FFEDC4" }}
              >
                <div className="w-1/6 flex  justify-center items-center font-bold text-lg">
                  {storageImages.length - 1 - storageImages.indexOf(x) + 1}
                </div>

                {storageImages.length - 1 - storageImages.indexOf(x) > 5 ? (
                  <div
                    className="w-5/6 flex justify-center items-center text-lg"
                    onClick={removeImage}
                    id={storageImages.indexOf(x)}
                  >
                    <IoTrashSharp /> <span className="pl-3"></span> bvisa
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
            </div>
          ))}
      </div>

      <div className="z-30 fixed" style={{ bottom: "0", right: "0" }}>
        <Navigation />
      </div>
    </div>
  )
}
